import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '../state/auth.store';

export const authGuard: CanActivateFn = (route, state) => {
    const authStore = inject(AuthStore);
    const router = inject(Router);

    if (authStore.isAuthenticated()) {
        return true;
    }

    if (authStore.accessToken()) {
        authStore.sessionExpiredLogout();
        return false;
    }

    return router.createUrlTree(
        ['/login'],
        { queryParams: { returnUrl: state.url } }
    );
};

export const loginGuard: CanActivateFn = () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);

    if (authStore.isAuthenticated()) {
        return router.createUrlTree(['/']);
    }

    return true;
};
